module.exports = __webpack_public_path__ + "img/thumb-alcoholvrije-chocoladetiramisu.59b7f8b3.jpeg";